import type {
  DealItemGenericProperty,
  DealItemWithVersions,
} from '@/lib/graphql/generated/graphql';

const COLOR_OPTION_NAMES = new Set([
  'couleur',
  'couleurs',
  'color',
  'colors',
  'coloris',
  'colour',
  'colours',
  'colore',
  'colori',
]);

export const findColorOption = (
  options: readonly DealItemGenericProperty[] | null | undefined
): DealItemGenericProperty | undefined =>
  options?.find((option) =>
    COLOR_OPTION_NAMES.has(option.name.trim().toLowerCase())
  );

/**
 * Finds sibling variants that can inherit a newly-added color because they use
 * the exact same first image and do not already carry a color option.
 */
export const findSameVisualVariantsMissingColor = (
  products: readonly DealItemWithVersions[],
  sourceProductId: string
): DealItemWithVersions[] => {
  const source = products.find((product) => product.id === sourceProductId);
  const sourceImage = source?.activeVersion.images[0];
  if (!source || !sourceImage) return [];

  return products.filter((product) => {
    if (product.id === source.id) return false;
    if (product.activeVersion.isSelected !== source.activeVersion.isSelected) {
      return false;
    }

    return (
      product.activeVersion.name === source.activeVersion.name &&
      product.activeVersion.images[0] === sourceImage &&
      !findColorOption(product.activeVersion.options)
    );
  });
};
